
import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { 
  Home, 
  Settings, 
  Users, 
  Building, 
  Image, 
  Calendar,
  User
} from "lucide-react";

interface DashboardNavItemsProps {
  activeTab: string;
  nursingHomeSlug?: string;
}

export function DashboardNavItems({ activeTab, nursingHomeSlug }: DashboardNavItemsProps) {
  const basePath = nursingHomeSlug ? `/owner/nursing-homes/${nursingHomeSlug}` : '';
  
  const navItems = [
    {
      label: "Overview",
      icon: Home,
      href: `${basePath}/`,
      id: "overview",
    },
    {
      label: "Profile",
      icon: Building,
      href: `${basePath}/profile`,
      id: "profile",
    },
    {
      label: "Media",
      icon: Image,
      href: `${basePath}/media`,
      id: "media",
    },
    {
      label: "Leads",
      icon: User,
      href: `${basePath}/leads`,
      id: "leads",
    },
    {
      label: "Staff",
      icon: Users,
      href: `${basePath}/staff`,
      id: "staff",
    },
    {
      label: "Calendar",
      icon: Calendar,
      href: `${basePath}/calendar`,
      id: "calendar",
    },
    {
      label: "Settings",
      icon: Settings,
      href: `${basePath}/settings`,
      id: "settings",
    },
  ];
  
  return (
    <div className="p-2">
      <nav className="flex flex-col gap-1">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          
          return (
            <Link
              key={item.id}
              to={item.href}
              className={cn(
                "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors",
                isActive 
                  ? "bg-grandpal-green text-white font-medium" 
                  : "hover:bg-gray-100"
              )}
            >
              <item.icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
